export const PHONE_NUMBER = "phone_number";
export const TOKEN = "token";
export const MANUAL_TOKEN = "manual_token";
export const USER_TOKEN = "user_token"
export const SAVE_USER_DETAIL = 'save_user_detail'
export const SAVE_DOCUMENT_STATUS = 'save_document_status'
export const SAVE_LOAN_ID = 'save_loan_id' 
export const SAVE_LOAN = 'save_loan' 
export const SAVE_LOAN_IN_STATUS = 'save_loan_status_in_detail'
export const SAVE_WITHDRAW_LOAN_STATUS = 'save_withdraw_loan_detail'
